module.exports = __webpack_public_path__ + "img/product-preview-83.808fe4c.png";